import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    // Redireciona para a página de login se o usuário não estiver autenticado
    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
